import React from "react";

const AppML_Databases = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Databases</h1>
      <p>This is the AppML Databases page content.</p>
    </div>
  );
};

export default AppML_Databases;
